import { LoadingIndicator, ToggleThemeButton } from 'react-admin';

export const AppBarToolbar = () => (
  <>
    {/* <LocalesMenuButton />
        <ThemeSwapper /> */}
    <ToggleThemeButton />
    <LoadingIndicator />
  </>
);
